<template>    
    <div class="checkbox-field">
        <div class="p-field-checkbox" :class="(inline ? 'p-field-checkbox-inline' : 'p-field-checkbox-block')" v-for="option in options" :key="option.name">
            <Checkbox :name="name" :id="name" :value="option.value" v-model="selected"></Checkbox>
            <label :for="name" v-html="label(option)"></label>
        </div>
        <div class="invalid-feedback" v-if="errors" v-text="errors"></div>
    </div>
</template>

<script>
import Checkbox from 'primevue/checkbox/sfc'

export default {
    props: {
        modelValue: [String, Boolean],
        options: Object,
        inline: {
            type: Boolean,
            default: true
        },
        errors: Object,
        t: Object,
        name: String
    },

    components: {
        Checkbox
    },

    emits: [
        'update:modelValue'
    ],

    data() {
        return {
            selected: null
        }
    },

    watch: {
        selected() {
            this.$emit('update:modelValue', this.selected)
        }
    },

    methods: {
        label(option) {
            if (this.t) {
                if (this.name+'.'+option.value in this.t) {
                    return this.t[this.name+'.'+option.value]
                }
            }            
            return option.label
        }
    }

};
</script>